import { HttpStatusCode } from '@angular/common/http';

export function getFfdNotesInvitationErrorKey(error: unknown): string {
  const errorResponse = error as { statusCode?: number; status?: number } | undefined;
  const isExpired = errorResponse?.statusCode === HttpStatusCode.Gone || errorResponse?.status === HttpStatusCode.Gone;
  return isExpired ? 'ffd_notes_invitation_link_expired_error' : 'ffd_notes_invitation_link_invalid_error';
}
